export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtStat';
export const NAME = 'Stat';
